var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.08 8.793a.98.98 0 0 0-1.398 0 1.01 1.01 0 0 0 0 1.414L21.421 15H7.989A.994.994 0 0 0 7 16c0 .552.443 1 .989 1H21.42l-4.739 4.793a1.01 1.01 0 0 0 0 1.414.98.98 0 0 0 1.398 0l6.776-6.853a.504.504 0 0 0 0-.708z"
  })));
};
export default SvgArrowRight;